import {login, getSmsCodeImg, getUserInfo} from "@/api";
import {ElMessage} from 'element-plus'
import loginImg from '@/assets/images/login_ch.png'

export default {
    data() {
        return {
            year: "2024",
            loginForm: {
                username: "",
                rememberMe: false,
                code: "",
                uuid: "",
                type: "clinicFee",
            },
            logining: false,
            // 验证码开关
            captchaOnOff: true,
            codeUrl: '',
            token: null,
            loginImg: loginImg,
            smsCodeText: "获取验证码",
            totalTime: 60,
            isCountDown: false
        }
    },
    created() {
        this.year = new Date().getFullYear();
        window.sessionStorage.clear();
        window.localStorage.clear();
    },
    methods: {
        toURL: function () {
            this.$router.push({path: '/admin/home'});
        },


        // 验证码倒计时
        getCountdown() {
            let clock =  window.setInterval(() => {
                this.isCountDown = true;
                this.smsCodeText = this.totalTime + 's后重新发送';
                this.totalTime --;
                if(this.totalTime < 0){
                    this.isCountDown = false;
                    this.totalTime = 60;
                    this.smsCodeText = "重新发送验证码";
                    window.clearInterval(clock);
                }
            }, 1000);
        },

        // 获取短信验证码
        getSmsCode() {
            var mobilePattern = /^1[3456789]\d{9}$/;
            if (!this.isCountDown) {
                const smsPhone = this.loginForm.username;
                if (smsPhone === "" || smsPhone === null || smsPhone === undefined) {
                    ElMessage.error({
                        message: '登录手机号不能为空！',
                        type: 'error'
                    });
                } else if (!mobilePattern.test(smsPhone)) {
                    ElMessage.error({
                        message: '手机号码格式不正确！',
                        type: 'error'
                    });
                } else {
                    this.getCountdown();
                    getSmsCodeImg(smsPhone).then(res => {
                        console.log(res);
                        let rdata = res.data;
                        if (rdata.code === 200) {
                            this.loginForm.uuid = rdata.uuid;
                        } else {
                            ElMessage.error({
                                message: rdata.msg,
                                type: 'error'
                            });
                        }
                    })
                }
            } else {
                ElMessage.error({
                    message: this.totalTime + 's后才可以重新发送验证码！',
                    type: 'error'
                });
            }

        },
        handleLogin: function () {
            const username = this.loginForm.username;
            const code = this.loginForm.code;
            if (username === "" || username === null || username === undefined) {
                ElMessage.error({
                    message: '登录手机号不能为空！',
                    type: 'error'
                });
            } else if (code === "" || code === null || code === undefined) {
                ElMessage.error({
                    message: '短信验证码不能为空！',
                    type: 'error'
                });
            } else {
                this.logining = true;
                const data = {
                    username: this.loginForm.username,
                    code: this.loginForm.code,
                    uuid: this.loginForm.uuid
                }
                login(data).then(res => {
                    // console.log(res)
                    this.logining = false;
                    if (res.code === 200) {
                        window.localStorage.clear();
                        window.sessionStorage.clear();
                        window.sessionStorage.setItem("xtoken", res.token);
                        this.getUserDetailInfo(); // 获取用户详细信息
                        setTimeout(()=>{
                            this.$router.push({path: '/admin/home'});
                        },1000)
                    } else if (res.code === 500) {
                        ElMessage.error({
                            message: res.msg,
                            type: 'error'
                        });
                    }
                }).catch(error => {
                    this.logining = false;
                    ElMessage.error({
                        message: error,
                        type: 'error'
                    });
                });

            }
        },

        // 获取用户详细信息
        getUserDetailInfo() {
            getUserInfo().then(res => {
                // console.log(res);
                if (res.data.code === 200) {
                    window.sessionStorage.setItem("user", JSON.stringify(res.data.user));
                    window.sessionStorage.setItem("roles", JSON.stringify(res.data.roles));
                    window.sessionStorage.setItem("permissions", JSON.stringify(res.data.permissions));
                }
            })
        },
    }
}
